import { useDispatch } from 'react-redux';
import { useTranslation, Trans } from 'react-i18next';

import { showModal } from '/shared/state/actions/modal';

import StyledFormFlex from '/shared/styled/form/StyledFormFlex';

import Button from '/shared/components/widgets/button/Button';
import IconEcks from '/shared/images/icons/icon-ecks.svg';
import StyledBasketClearItems from './__styled__/StyledBasketClearItems';
import type { AppDispatch } from '/business/shared/state/store';

type BasketClearItem = {
  itemId?: number | string | null;
};

type BasketClearItemsProps = {
  deleteCallbackButton?: false | (() => void);
  deleteItems?: BasketClearItem[];
};

function BasketClearItems({ deleteItems = [], deleteCallbackButton = false }: BasketClearItemsProps) {
  const dispatch = useDispatch<AppDispatch>();
  const { t } = useTranslation();
  return (
    <StyledBasketClearItems>
      <StyledFormFlex $hasPadding>
        <Button
          onClick={() => {
            if (deleteCallbackButton) {
              deleteCallbackButton();
            } else {
              dispatch(
                showModal({
                  name: 'BASKET_ITEM_DELETE_MULTIPLE',
                  metadata: {
                    deleteItems,
                  },
                }),
              );
            }
          }}
        >
          <img src={IconEcks} alt={t('business:Buttons.removeAll', 'Remove All')} height="14" />
        </Button>
        <div>
          <Button
            $secondary
            $small
            onClick={() => {
              if (deleteCallbackButton) {
                deleteCallbackButton();
              } else {
                dispatch(
                  showModal({
                    name: 'BASKET_ITEM_DELETE_MULTIPLE',
                    metadata: {
                      deleteItems,
                    },
                  }),
                );
              }
            }}
          >
            {/* @i18n: Remove All */}
            <Trans i18nKey="business:Buttons.removeAll" />
          </Button>
        </div>
      </StyledFormFlex>
    </StyledBasketClearItems>
  );
}

export default BasketClearItems;
